export interface ContractDeadlineInfo {
  label: 'Просрочка' | 'Осталось' | null;
  months: number | null;
  days: number | null;
  overdue: boolean;
}

export function formatContractDeadline(endDate?: string | null): ContractDeadlineInfo {
  return formatDeadlineRelativeTo(endDate, null);
}

/** Компактное отображение срока для таблицы: «2 мес. 5 дн.» */
export function formatDeadlineCompact(info: ContractDeadlineInfo): string {
  if (!info.label) {
    return '—';
  }
  const parts: string[] = [];
  if (info.months != null && info.months > 0) {
    parts.push(`${info.months} мес.`);
  }
  if (info.days != null) {
    parts.push(`${info.days} дн.`);
  }
  return parts.length > 0 ? parts.join(' ') : '—';
}

/** Просрочка/остаток крайнего срока относительно опорной даты (по умолчанию — сегодня). */
export function formatDeadlineRelativeTo(
  endDate?: string | null,
  referenceDate?: string | null,
): ContractDeadlineInfo {
  if (!endDate?.trim()) {
    return { label: null, months: null, days: null, overdue: false };
  }
  const end = new Date(`${endDate.trim()}T00:00:00`);
  if (Number.isNaN(end.getTime())) {
    return { label: null, months: null, days: null, overdue: false };
  }
  const reference = referenceDate?.trim()
    ? new Date(`${referenceDate.trim()}T00:00:00`)
    : new Date();
  if (Number.isNaN(reference.getTime())) {
    return { label: null, months: null, days: null, overdue: false };
  }
  reference.setHours(0, 0, 0, 0);
  const totalDays = Math.round((end.getTime() - reference.getTime()) / 86_400_000);
  const overdue = totalDays < 0;
  const abs = Math.abs(totalDays);
  const months = Math.floor(abs / 30);
  const days = abs % 30;
  return {
    label: overdue ? 'Просрочка' : 'Осталось',
    months,
    days,
    overdue,
  };
}
